// Common Colors
export const PRIMARY = '#97144D';
export const TEXT_INPUT_BACKGROUND = "#F9FCFF";
export const TEXT_INPUT_BORDER = "#D1E8FF";
export const TEXT_INPUT = "#4A4A4A";
export const WHITE = "#FFFFFF";
export const LOADER_SHADOW = "#ED116429";
export const CARD_SHADOW = "#0000000D"

// Key Constants
export const AUTH_KEY = (txnId: string) => `AUTH_KEY-${txnId}`;
export const APPLICATION_LOADED = 'APPLICATION_LOADED'
export const OTP_LENGTH = 6
export const BACKSPACE_KEYCODE = 8
export const DELETE_KEYCODE = 46
export const ENTER_KEYCODE = 13

// ARGO Status Codes
export const ARGO_SUCCESS = 6000;
export const ARGO_INVALID_CREDENTIALS = 4003;
export const ARGO_TXN_NOT_FOUND = 7000;
export const ARGO_USER_NOT_FOUND = 7001;
export const TXN_TIMED_OUT = 7009;
export const ARGO_CUSTOMER_NOT_FOUND = 7002;
export const ARGO_TXN_LOCKED = 7003;
export const ARGO_USER_DISABLED = 7006;
export const OTP_EXHAUSTED = 1234;
export const NEW_ACCOUNT = 7011;

export const ERROR_CODES = {
  COMMON: {
    ARGO_INVALID_ACCOUNT: 5000,
    NO_ACCOUNT_FOUND: 5001,
    UNDERAGE: 5002,
    DATA_NOT_FOUND: 5005,
    ACCOUNT_NOT_ACTIVE: 5009,
    CUSTOMER_VINTAGE_EXCEPTION: 5011,
    INVALID_CONSTITUTION_CODE: 5012,
    INVALID_SCHEME_CODE: 5013,
    MOBILE_NOT_FOUND: 5003,
    DEMOG_NOT_FOUND: 7200,
    BENEFICIARY_NOT_FOUND: 7300,
    FEMA_LIMIT_ERROR: 7400,
    ACCOUNT_BALANCE_EXCEPTION: 7004,
    ARC_BANK_STATEMENT_ERR: 8505,	
    PAN_MISMATCH_WITH_CBS: 5014,	
    OPER_ACCOUNT_NOT_VALID: 7403,
  },
  ACCOUNT_UPDATE_ERROR: {
    PAN_NOT_VALID: 5004,
    KYC_NOT_DONE: 5010,
    PAN_NOT_UPDATED_WITH_CBS: 7404,
  },
  EXCEPTIONS: {
    ACCOUNT_FORMAT_EXCEPTION: 5006,
    SOURCE_OF_FUNDS_EXCEPTION: 5007,
    REMITANCE_AMOUNT_EXCEPTION: 5008,
    FILE_SIZE_EXCEPTION: 8500,
    FILE_FORMAT_EXCEPTION: 8501,
    PERFIOS_STATEMENT_UPLOAD_FAILURE: 8502
  }
}

export const NOT_AUTHORIZED_ERROR = {
  code: 403,
  error_message: "Not authorized",
  status: "ERROR",
  data: null
}

export const DECLARATION_FILES = {
  "tnc": "TncDeclaration.html",
  "tax": "TaxDeclaration.html",
  "update": "UploadConsent.html"
}

// Endpoints
const BASE_URL = process.env.REACT_APP_BACKEND_BASE_ENDPOINT
export const API_ENDPOINTS = {
  IB_AUTH: `${BASE_URL}/api/login/ib`,
  LOGOUT: `${BASE_URL}/transactions/logout`,
  GET_TRANSACTION_DETAILS: `${BASE_URL}/transactions/summary`,
  SUBMIT_TRANSACTION_CONSENT: `${BASE_URL}/transactions/summary`,
  GET_ACCOUNT_BALANCE: `${BASE_URL}/transactions/account-balance`,
  GET_PAYMENT_SUMMARY: `${BASE_URL}/transactions/remit`,
  SUBMIT_TNC_CONSENT: `${BASE_URL}/transactions/tos?declarationType=` + DECLARATION_FILES.tnc,
  GET_PROFILE_DETAILS: `${BASE_URL}/transactions/header-details`,
  GENERATE_OTP: `${BASE_URL}/transactions/generate-otp`,
  VALIDATE_OTP: `${BASE_URL}/transactions/validate-otp`,
  ARC_APPROVE: `${BASE_URL}/transactions/approve`,
  AUM_MOBILE: `${BASE_URL}/transactions/mobile`,
  GET_INSTITUTION_LIST: `${BASE_URL}/transactions/institutions?pattern=`,
  INITIATE_UPLOAD_DOC: `${BASE_URL}/transactions/initiate-stmt-upload`,
  UPLOAD_DOCUMENTS: `${BASE_URL}/transactions/upload-statements?perfios-txnId=`,
  UPLOAD_DETAILS: `${BASE_URL}/transactions/uploadDetails`,
  RESUME_JOURNEY: `${BASE_URL}/transactions/resume-journey`,
  TNC_GET: `${BASE_URL}/transactions/file-content?fileName=` + DECLARATION_FILES.tnc,
  TAX_GET: `${BASE_URL}/transactions/file-content?fileName=` + DECLARATION_FILES.tax,
  MPIN_LOGIN: `${BASE_URL}/api/mpin/login`,
  UPDATE_GET: `${BASE_URL}/transactions/file-content?fileName=` + DECLARATION_FILES.update,
  PERFIOS_COMPLETE: `${BASE_URL}/transactions/complete`,
}

export const APP_URLS = {
  LOGIN: "/login/:txnId",
  TRANSACTION_DETAILS: "/transaction-details/:txnId",
  TRANSACTION_SUMMARY: "/transaction-summary/:txnId",
  ERROR: "/error/:txnId",
  TNC: "/tnc/:txnId",
  OTP: "/verify-otp/:txnId",
  SUCCESS: "/success/:txnId",
  UNAUTHORIZED: '/error',
  COMMON_ERROR: '/error',
  DOCUMENT_UPLOAD: '/upload/:txnId',
  NTB: '/ntb/:txnId',
  CONFIRM: '/thank-you/:txnId',
  TEMP_DOWN: '/temp-down',
  ERROR_LOGIN: '/login-error',
  MPIN_SUCCESS: "/mpin-success/:txnId",	
  MPIN_ERROR: "/mpin-fail/:txnId",
  VERIFY_SUCCESS:'/verification-status/:txnId'
}


// User Endpoints
export const REGISTER_ENDPOINT = "https://retail.axisbank.co.in/wps/portal/rBanking/axisebanking/AxisGenOnlinePwd"
export const FORGOT_PASSWORD_ENDPOINT = "https://retail.axisbank.co.in/wps/portal/rBanking/axisebanking/AxisForgotPassword"
export const ENABLE_LOGIN_ID_ENDPOINT = "https://retail.axisbank.co.in/wps/portal/rBanking/axisebanking/AxisEnableLoginId"
export const LOGOUT_REDIRECTION_ENDPOINT = "https://www.axisbank.com/"

const LEAP_URL = process.env.REACT_APP_LEAP_REDIRECT_ENDPOINT 
export const LEAP_REDIRECTION_ENDPOINT = (txnId: string) => LEAP_URL + txnId

// Resident Indian purpose code
export const RI_PURPOSE_CODE = "Foreign Equity Investment"

//encrytion Keys

// export const GA_ENCRYPT_KEY = "71D35B2C84E1A439B1BE06DCE04BD924"
export const MOBILE_REGEX = /^[1-9]\d{9}$/
